<template>
  <modal
    :show="show"
    header-classes="justify-content-center center"
    :disable-background-close="true"
    @close="handleClose()"
  >
    <h4 slot="header" class="title">
      Add New Participant
    </h4>
    <h5 v-if="!unselectedParticipants" style="text-align:center">
      Loading...
    </h5>
    <el-autocomplete
      v-if="unselectedParticipants"
      v-model="query"
      placeholder="Search people"
      :fetch-suggestions="queryEligibleParticipants"
      value-key="name"
      @select="handleSelectParticipant"
      id="searchAutocomplete-addparticipants"
      v-show="notSelected"
      style="width: 100%;"
    />

    <collapse
      ref="childCollapseComponent"
      v-show="!selectedParticipant"
    >
      <collapseItem
        title="Don't see who you're looking for?"
        class="bold-collapse-title"
        :show-caret="false"
      >
        <newPersonForm
          ref="childFormComponent"
          :is-embedded-in-modal="true"
          @savedPerson="captureSavedPerson($event)"
        />
      </collapseItem>
    </collapse>

    <p
      v-if="selectedParticipant"
    >
      {{ selectedParticipant.name }} joined on:
      <datepicker
        class="datepicker"
        placeholder="Select Date"
        v-model="startDate"
        :disabled-dates="invalidDates"
      />
    </p>
    <p
      v-show="selectedParticipantError"
      :class="{
        validationErrorText: selectedParticipantError
      }"
    >
      {{ selectedParticipantError }}
    </p>
    <div>
      <p
        v-show="startDateError"
        :class="{
          validationErrorText: startDateError
        }"
      >
        {{ startDateError }}
      </p>
    </div>

    <template slot="footer">
      <p-button @click="handleClose">
        Cancel
      </p-button>
      <p-button class="custom-modal-type" @click="validateInput">
        Save
      </p-button>
    </template>
  </modal>
</template>

<script>
import {
    mapState
} from 'vuex';
import Datepicker from 'vuejs-datepicker';
import modal from '../../UIComponents/Modal';
import newPersonForm from '../../People/NewUserForm';
import collapse from '../../UIComponents/Collapse/Collapse';
import collapseItem from '../../UIComponents/Collapse/CollapseItem';

export default {
    name: 'AddBSPModal',
    components: {
        modal,
        Datepicker,
        collapse,
        collapseItem,
        newPersonForm
    },
    data() {
        return {
            namespace: 'BibleStudies',
            notSelected: true,
            query: '',
            unselectedParticipants: null,
            selectedParticipant: null,
            startDate: null,
            invalidDates: {
                to: new Date(this.bibleStudy.start_date)
            },
            startDateError: null,
            selectedParticipantError: null,
        };
    },
    props: {
        show: Boolean,
        bibleStudy: Object,
    },
    computed: {
        ...mapState({
            error: (state) => state.BibleStudies.error,
            eligibleParticipants: (state) => state.BibleStudies.eligibleParticipants
        })
    },
    watch: {
        eligibleParticipants() {
            this.unselectedParticipants = this.eligibleParticipants;
        }
    },
    methods: {
        validateInput() {
            switch (this.selectedParticipant == null) {
            case true:
                this.selectedParticipantError = 'Please select a person from the search bar above or click "Don\'t see who you\'re looking for?" to add them.';
                break;
            default:
                this.selectedParticipantError = null;
            }
            switch (this.startDate == null && !this.selectedParticipantError) {
            case true:
                this.startDateError = 'Please select a join date.';
                break;
            default:
                this.startDateError = null;
            }
            switch (!this.startDateError && !this.selectedParticipantError) {
            case true:
                this.handleSave();
                break;
            default:
                break;
            }
        },
        captureSavedPerson(event) {
            this.$message(`Successfully saved ${event.name} as a contact.`);
            this.handleSelectParticipant(event);
            this.$refs.childFormComponent.clearInputs();
            this.$refs.childCollapseComponent.deactivateAll();
        },
        handleSave() {
            const participantData = {
                person_id: this.selectedParticipant.id,
                start_date: this.transformJSDateForPayload(this.startDate),
                bible_study_id: this.bibleStudy.id
            };
            this.$store.dispatch(`${this.namespace}/storeNewBibleStudyParticipant`, {
                participant_data: participantData,
            }).then(this.handleClose());
        },
        handleClose() {
            this.selectedParticipant = null;
            this.selectedParticipantError = null;
            this.startDate = null;
            this.startDateError = null;
            this.query = '';
            this.notSelected = true;
            this.$refs.childCollapseComponent.deactivateAll();
            this.$emit('close');
        },
        queryEligibleParticipants(queryString, callback) {
            if (queryString.length === 0) callback(this.unselectedParticipants);
            else {
                const results = queryString
                    ? this.unselectedParticipants.filter(this.createFilter(queryString)) : this.unselectedParticipants;
                callback(results);
            }
        },
        createFilter(queryString) {
            return (participant) => participant.name.toLowerCase().includes(queryString.toLowerCase());
        },
        handleSelectParticipant(participant) {
            this.selectedParticipant = participant;
            this.notSelected = false;
            this.selectedParticipantError = null;
        },
    },
};
</script>
<style>
.modal-body{
    display: flex;
    justify-content: center;
}
</style>
